import src from "IMAGE";
export default { src, width: 375, height: 282, blurWidth: 0, blurHeight: 0};
